module.exports = __webpack_public_path__ + "img/empty.bde9da34.png";